import React from "react";
import { separate } from "../../../Utils/SeprateNumber/SeprateThreeNumber";
import { JalaliDate } from "../../../Utils/JalaliDate/JalaliDate";

const paymentTypes = {
  pgw: "بانک پارسیان",
  sadad: "بانک ملی",
  wallet: "کیف پول",
};

const FactorTransactionDetail = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <div className="spinner-border text-primary" role="status" />
        <span className="me-2">در حال دریافت جزئیات پرداخت...</span>
      </div>
    );
  }

  if (data?.status !== 0) {
    return (
      <p className="text-danger text-center">
        دریافت اطلاعات پرداخت با خطا مواجه شد.
      </p>
    );
  }

  if (!data?.transactions?.length) {
    return (
      <p className="text-center py-3">تراکنشی برای این فاکتور ثبت نشده است.</p>
    );
  }
  const sortedTransactions = [...data.transactions].sort(
    (a, b) => Number(b.id) - Number(a.id),
  );
  return (
    <div className="table-responsive" style={{ direction: "rtl" }}>
      <table className="table table-bordered table-striped text-center align-middle">
        <thead>
          <tr>
            <th>شناسه تراکنش</th>
            <th>روش پرداخت</th>
            <th>تاریخ</th>
            <th>مبلغ (تومان)</th>
            <th>شماره کارت</th>
            <th>شماره پیگیری</th>
            <th>وضعیت</th>
          </tr>
        </thead>

        <tbody>
          {sortedTransactions.map((transaction) => {
            const detail = transaction.payment_type_detail || {};

            return (
              <tr key={transaction.id}>
                <td>{transaction.id}</td>
                <td>
                  {paymentTypes[transaction.payment_type] ||
                    transaction.payment_type}
                </td>
                <td>{JalaliDate(transaction.date)}</td>
                <td>{separate(detail.amount || 0)}</td>
                <td>{detail.cardnumbermasked || "-"}</td>
                <td>{detail.rrn || detail.straceno || "-"}</td>
                <td>
                  {transaction.payment_type === "wallet" ||
                  (detail.hashcardnumber?.trim() && detail.rrn?.trim()) ? (
                    <span style={{ color: "green" }}>موفق</span>
                  ) : (
                    <span style={{ color: "red" }}>ناموفق</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FactorTransactionDetail;
